import { render, staticRenderFns } from "./cabinet-fl223-notice-card.vue?vue&type=template&id=5990c02b&scoped=true&"
import script from "./cabinet-fl223-notice-card.vue?vue&type=script&lang=js&"
export * from "./cabinet-fl223-notice-card.vue?vue&type=script&lang=js&"
import style0 from "./cabinet-fl223-notice-card.vue?vue&type=style&index=0&id=5990c02b&scoped=true&lang=css&"
import style1 from "./cabinet-fl223-notice-card.vue?vue&type=style&index=1&id=5990c02b&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5990c02b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5990c02b')) {
      api.createRecord('5990c02b', component.options)
    } else {
      api.reload('5990c02b', component.options)
    }
    module.hot.accept("./cabinet-fl223-notice-card.vue?vue&type=template&id=5990c02b&scoped=true&", function () {
      api.rerender('5990c02b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cabinet/fl223/cards/cabinet-fl223-notice-card.vue"
export default component.exports